import { BrowserRouter, Route, Routes } from "react-router-dom";

import { ConfigProvider } from "antd";
import AppLayout from "./components/Layout/AppLayouts";

import PrivateRoute from "./components/PrivateRoute";
import { Toaster } from "react-hot-toast";

import React, { Suspense } from "react";
import LoginPage from "./pages/LoginPage";
import UnauthorizedPage from "./pages/UnauthorizedPage";
import NotFound from "./pages/NotFound";
import AccueilPage from "./pages/DashboardPage";
import ProjectsListPage from "./pages/ProjectsListPage";
import LancerVisitePage from "./pages/LancerVisitePage";
import AjouterProjetPage from "./pages/AjouterProjetPage";
import AffecterProjetPage from "./pages/AffecterProjetPage";
import MediaTestPage from "./pages/MediaTestPage";
import UsersPage from "./pages/UsersPage";
import ProjectDetailsPage from "./pages/ProjectDetailsPage";

// const LoginPage = React.lazy(() => import("./pages/LoginPage"));
// const AccueilPage = React.lazy(() => import("./pages/AccueilPage"));
// const ProjectsListPage = React.lazy(() => import("./pages/ProjectsListPage"));
// const LancerVisitePage = React.lazy(() => import("./pages/LancerVisitePage"));
// const UsersPage = React.lazy(() => import("./pages/UsersPage"));
// const AjouterProjetPage = React.lazy(() => import("./pages/AjouterProjetPage"));
// const ProjectDetails = React.lazy(
//   () => import("./components/ProjectDetails/ProjectDetails")
// );
// const UnauthorizedPage = React.lazy(() => import("./pages/UnauthorizedPage"));
// const NotFound = React.lazy(() => import("./pages/NotFound"));
// const AffecterProjetPage = React.lazy(
//   () => import("./pages/AffecterProjetPage")
// );
// const MediaTestPage = React.lazy(() => import("./pages/MediaTestPage"));

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#42005a",
          fontFamily: "QuickSand",
        },
      }}
    >
      <BrowserRouter>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path={"/login"} element={<LoginPage />} />
            <Route path="/unauthorized" element={<UnauthorizedPage />} />
            <Route path="*" element={<NotFound />} />

            <Route path="/" element={<AppLayout />}>
              <Route
                element={
                  <PrivateRoute roles={["admin", "controleur", "visiteur"]} />
                }
              >
                
                <Route path={"/lancerVisite"} element={<LancerVisitePage />} />
              </Route>

              <Route element={<PrivateRoute roles={["admin", "controleur"]} />}>
              <Route index element={<AccueilPage />} />
                <Route
                  path={"/ajouterprojet"}
                  element={<AjouterProjetPage />}
                />
                <Route
                  path={"/affecterProjet"}
                  element={<AffecterProjetPage />}
                />
                <Route path={"/projectsList"} element={<ProjectsListPage />} />
                <Route
                  path={"/projectDetails"}
                  element={<ProjectDetailsPage />}
                />
              </Route>

              <Route element={<PrivateRoute roles={["admin"]} />}>
                <Route path={"/users"} element={<UsersPage />} />
                
              </Route>
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        reverseOrder={false}
        toastOptions={{
          // Define default options
          className: "",
          duration: 5000,
          style: {
            background: "#363636",
            color: "#fff",
          },
          // Default options for specific types
          success: {
            style: {
              border: "1px solid #42005a",
              padding: "16px",
              color: "#42005a",
              fontSize: "16px",
              backgroundColor: "#ffffff",
            },
            iconTheme: {
              primary: "#42005a",
              secondary: "#FFFAEE",
            },
          },
          // Promise-specific styling
          loading: {
            style: {
              border: "1px solid #42005a",
              padding: "16px",
              color: "#42005a",
              fontSize: "16px",
              backgroundColor: "#ffffff",
            },
            iconTheme: {
              primary: "#42005a",
              secondary: "#FFFAEE",
            },
          },
          error: {
            style: {
              border: "1px solid #e74c3c",
              padding: "16px",
              color: "#e74c3c",
              fontSize: "16px",
              backgroundColor: "#ffffff",
            },
            iconTheme: {
              primary: "#e74c3c",
              secondary: "#FFFAEE",
            },
          },
        }}
      />
    </ConfigProvider>
  );
}

export default App;
